import React, { Component } from 'react';
import style from './CheckBoxWithLabel.module.css';
// import logoImage from '../assets/images/header_logo.svg';
// import MenuLeft from './MenuLeft.js';
//import artwork from '../assets/images/artwork.svg';

class CheckBoxWithLabel extends Component {
    render() {
        return (
            <div className={style.area}>
                <label>

                    <input
                        type="checkbox"
                        name={this.props.name}
                        checked={this.props.value}
                        onChange={this.props.onChange}
                    />
                    {this.props.label}
                </label>
            </div>
        );
    }
}
export default CheckBoxWithLabel